import "./web.7c552b00.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $bNfEN = parcelRequire("bNfEN");

var $bHLtA = parcelRequire("bHLtA");
// Display disassembled code in UI.

var $bNfEN = parcelRequire("bNfEN");

var $6cf6a042bb642adb$export$2e2bcd8739ae039 = {
    file_json: ""
};


/**
 * 
 * @param {any} instructionObj 
 * @param {number} offset 
 * @returns 
 */ function $e03ed96c1d6f2f1f$var$GenerateInstructionHTML(instructionObj, offset) {
    let p = document.createElement("p");
    p.classList.add("font-fira");
    let addrElement = document.createElement("span");
    addrElement.classList.add("instruction-address");
    addrElement.textContent = `0x${offset.toString(16).padStart(8, "0").toUpperCase()} `;
    addrElement.id = "addr_" + addrElement.textContent.trim();
    let itnElement = document.createElement("span");
    itnElement.classList.add("text-green-500");
    itnElement.textContent = (0, $bNfEN.instructionArray)[instructionObj.instruction] + " ";
    let argsElement = null;
    if ((0, $bNfEN.instructionArray)[instructionObj.instruction] == "jmp" || (0, $bNfEN.instructionArray)[instructionObj.instruction] == "cndjmp" || (0, $bNfEN.instructionArray)[instructionObj.instruction] == "call" || (0, $bNfEN.instructionArray)[instructionObj.instruction] == "cndcall") {
        argsElement = document.createElement("a");
        argsElement.style.textDecoration = "underline";
        argsElement.href = `#addr_${instructionObj.data[0]}`;
    } else if ((0, $bNfEN.instructionArray)[instructionObj.instruction] == "lda" || (0, $bNfEN.instructionArray)[instructionObj.instruction] == "sta") {
        argsElement = document.createElement("a");
        argsElement.style.textDecoration = "underline";
        argsElement.href = `#def_${instructionObj.data[0]}`;
    } else argsElement = document.createElement("span");
    argsElement.classList.add("text-cyan-600");
    if (instructionObj.data != null) instructionObj.data.forEach((element)=>{
        argsElement.textContent += element + " ";
    });
    p.appendChild(addrElement);
    p.appendChild(itnElement);
    p.appendChild(argsElement);
    return p;
}
async function $e03ed96c1d6f2f1f$export$3657776f5b36088f(codeObject) {
    (0, $6cf6a042bb642adb$export$2e2bcd8739ae039).file_json = JSON.stringify(codeObject, null, 3);
    // Display instructions
    if (codeObject.instructions.length == 0) (0, $1483cb1c8d319a50$export$4bae052d99470dd0).querySelector("p").textContent = "No instructions";
    else {
        (0, $1483cb1c8d319a50$export$4bae052d99470dd0).replaceChildren();
        for(let i = 0; i < codeObject.instructions.length; i++){
            const element = codeObject.instructions[i];
            (0, $1483cb1c8d319a50$export$4bae052d99470dd0).appendChild($e03ed96c1d6f2f1f$var$GenerateInstructionHTML(element, i * 5 + await (0, $bNfEN.goputer).memOffset + codeObject.start_indexes[2]));
        }
    }
    // Display interrupt subscriptions
    (0, $1483cb1c8d319a50$export$f88d6906383a6ada).replaceChildren();
    var interruptTable = document.createElement("table");
    interruptTable.classList.add("w-full");
    for (const [key, value] of Object.entries(codeObject.interrupt_table)){
        let interruptRow = document.createElement("tr");
        let interruptName = document.createElement("td");
        interruptName.textContent = (0, $bNfEN.interruptArray)[parseInt(key)] + " ";
        interruptRow.appendChild(interruptName);
        let interruptAddress = document.createElement("td");
        interruptAddress.classList.add("font-fira");
        interruptAddress.textContent = await (0, $bNfEN.goputer).util.convertHex(value, false);
        interruptRow.appendChild(interruptAddress);
        interruptTable.appendChild(interruptRow);
    }
    (0, $1483cb1c8d319a50$export$f88d6906383a6ada).appendChild(interruptTable);
    // Display definitions
    if (codeObject.program_definitions.length == 0) (0, $1483cb1c8d319a50$export$cbdeb1ad9c1460cf).querySelector("p").textContent = "No definitions.";
    else {
        (0, $1483cb1c8d319a50$export$cbdeb1ad9c1460cf).replaceChildren();
        let totalDefinitionLength = 0;
        for(let i = 0; i < codeObject.program_definitions.length; i++){
            const element = codeObject.program_definitions[i];
            let definitionAddress = "0x" + (await (0, $bNfEN.goputer).memOffset + codeObject.start_indexes[1] + totalDefinitionLength).toString(16).padStart(8, "0").toUpperCase();
            totalDefinitionLength += atob(element).length + 4;
            let definitionContainer = document.createElement("div");
            definitionContainer.classList.add("p-2");
            let definitionInfo = document.createElement("p");
            definitionInfo.textContent = `${atob(element).length} bytes at ${definitionAddress}`;
            definitionInfo.id = `def_${definitionAddress}`;
            definitionInfo.classList.add("definition-info");
            let definitionText = document.createElement("h3");
            definitionText.classList.add("font-bold");
            definitionText.textContent = "Text representation";
            let definition = document.createElement("p");
            definition.classList.add("table-code");
            definition.textContent = atob(element);
            let definitionTitle1 = document.createElement("h3");
            definitionTitle1.classList.add("font-bold");
            definitionTitle1.textContent = "Hex representation";
            let definitionHex = document.createElement("p");
            definitionHex.classList.add("table-code");
            // https://stackoverflow.com/a/41106346/7345078
            let intArray = Uint8Array.from(atob(element), (c)=>c.charCodeAt(0));
            intArray.forEach((element)=>{
                definitionHex.textContent += element.toString(16).toUpperCase().padStart(2, "0");
            });
            definitionContainer.appendChild(definitionInfo);
            definitionContainer.appendChild(definitionText);
            definitionContainer.appendChild(definition);
            definitionContainer.appendChild(definitionTitle1);
            definitionContainer.appendChild(definitionHex);
            (0, $1483cb1c8d319a50$export$cbdeb1ad9c1460cf).appendChild(definitionContainer);
        }
    }
}



var $1483cb1c8d319a50$var$uploadedBytes = [];
var $1483cb1c8d319a50$var$fileUploaded = false;
var $1483cb1c8d319a50$var$file_disassembled = false;
var $1483cb1c8d319a50$var$fileName = "";
(0, $bNfEN.goputer).workerInit();
(0, $bHLtA.setVersion)();
const $1483cb1c8d319a50$var$ButtonUpload = document.getElementById("button-upload");
const $1483cb1c8d319a50$var$ButtonDisassemble = document.getElementById("button-disassemble");
const $1483cb1c8d319a50$var$ButtonDownload = document.getElementById("button-download");
const $1483cb1c8d319a50$var$FileForm = document.getElementById("file-form");
const $1483cb1c8d319a50$export$4bae052d99470dd0 = document.getElementById("container-instructions");
const $1483cb1c8d319a50$export$f88d6906383a6ada = document.getElementById("container-interrupt-table");
const $1483cb1c8d319a50$export$cbdeb1ad9c1460cf = document.getElementById("container-definitions");
$1483cb1c8d319a50$var$FileForm.addEventListener("change", (e)=>{
    $1483cb1c8d319a50$var$fileName = e.target.files[0].name;
    var reader = new FileReader();
    reader.onload = function() {
        var arrayBuffer = this.result, array = new Uint8Array(arrayBuffer);
        $1483cb1c8d319a50$var$uploadedBytes = array;
    };
    reader.readAsArrayBuffer(e.target.files[0]);
    $1483cb1c8d319a50$var$fileUploaded = true;
    $1483cb1c8d319a50$var$ButtonDisassemble.removeAttribute("disabled");
});
$1483cb1c8d319a50$var$ButtonUpload.addEventListener("click", (e)=>{
    $1483cb1c8d319a50$var$FileForm.click();
});
$1483cb1c8d319a50$var$ButtonDisassemble.addEventListener("click", async (e)=>{
    if (String.fromCharCode(...$1483cb1c8d319a50$var$uploadedBytes.slice(0, 4)) != "GPTR") {
        alert("Invalid file!");
        return;
    }
    let code = await (0, $bNfEN.goputer).disassembleCode($1483cb1c8d319a50$var$uploadedBytes);
    (0, $e03ed96c1d6f2f1f$export$3657776f5b36088f)(code);
    $1483cb1c8d319a50$var$file_disassembled = true;
    $1483cb1c8d319a50$var$ButtonDownload.removeAttribute("disabled");
});
$1483cb1c8d319a50$var$ButtonDownload.addEventListener("click", (e)=>{
    var file_element = document.createElement("a");
    file_element.setAttribute("href", `data:text/plain;charset=utf-8,${encodeURIComponent((0, $6cf6a042bb642adb$export$2e2bcd8739ae039).file_json)}`);
    file_element.setAttribute("download", `disassembled_${$1483cb1c8d319a50$var$fileName}.json`);
    file_element.style.display = "none";
    document.body.appendChild(file_element);
    file_element.click();
    document.body.removeChild(file_element);
});


//# sourceMappingURL=disassembler.3d0651b6.js.map
